module.exports = __webpack_public_path__ + "assets/img/1_1659_big.77d31845.jpg";